module.exports = __webpack_public_path__ + "static/media/13_BG_Beige.ef6d3fd6.png";